export const ACCOUNT_DELETION_REASONS_LIST_KEY = 'ACCOUNT_DELETION_REASONS_LIST';
export const ACCOUNT_DELETION_REASONS_ONE_KEY = 'ACCOUNT_DELETION_REASONS_ONE_KEY';
